// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-672.8 -2887 1.6 8.2"><path d="M-671.2-2879.7v.4a.472.472 0 01-.5.5h-.5a.472.472 0 01-.5-.5v-.4a.472.472 0 01.5-.5h.5a.472.472 0 01.5.5zm0-6.9l-.1 5.1a.472.472 0 01-.5.5h-.4a.56.56 0 01-.5-.6l-.1-5c0-.3.2-.4.5-.4h.6c.3 0 .5 0 .5.4z"/></svg>
);

export default fn;
